import { autoinject } from "aurelia-framework";
import { ComponentBase, StandardLoadOptions } from "app/shared/lib/essette-site";
import * as api from 'app/shared/lib/essette-api';
import * as UM from 'app/um/models/essette-api';

@autoinject
export class PreServiceDayService {

    ////****************** Fields and Properties ************************************////



    ////****************** Functions *****************////
    constructor(public api: api.Api) { }



    ////****************** Queries **************************************************////
    @api.apiCall
    public async loadAdmissionPreServiceDays(authId: string, options?: StandardLoadOptions, includes: string[] = [], fields: string[] = []): Promise<api.ApiQueryResponse<UM.AdmissionPreServiceDay>> {

        const query = new api.ApiQuery('um/admissions/preServiceDays')
            .filterString('auth.Id', authId)
            .applyStandardLoadOptions(options, { applyPaginationSizeToDetails: true })
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }

    @api.apiCall
    public async insertAdmissionPreServiceDay(day: UM.AdmissionPreServiceDay): Promise<api.ApiPostResponse> {
        const action = new api.ApiAction('insert', `um/admissions/preServiceDays`, day);

        return await this.api.post(action);
    }

    @api.apiCall
    public async updateAdmissionPreServiceDay(day: UM.AdmissionPreServiceDay): Promise<api.ApiPostResponse> {
        const action = new api.ApiAction('update', `um/admissions/preServiceDays/${day.id}`, day);

        return await this.api.post(action);
    }

    @api.apiCall
    public async loadDeterminations(options?: StandardLoadOptions, includes: string[] = [], fields: string[] = []): Promise<api.ApiQueryResponse<UM.AuthStatus>> {
        const query = new api.ApiQuery('um/auths/statuses')
            .filterBoolean('determination.isDetermination', true)
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }

    @api.apiCall
    public async loadLevelsOfCare(options?: StandardLoadOptions, includes: string[] = [], fields: string[] = []): Promise<api.ApiQueryResponse<UM.LevelOfCare>> {
        const query = new api.ApiQuery('um/levelsofcare')
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }
}

